import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DatabaseService } from '../services/database.service';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {

  @Input() titulo;
  @Input() descripcion;
  @Input() botonTitulo=null;
  @Input() botonRuta;
  @Input() imageUrl;
  @Input() modoVisualizacion='vista';
  @Input() showSelector=true;
  
  continentes = [];
  paises = [];
  ciudades = [];
  selectedContinent='';
  selectedCountry='';
  selectedCity='';

  imageFile = null;
  imageFileName = null;

  classMargen = "jumbotron";
  _margen = true;

  get margen(): boolean {
    return this._margen;    
  }

  @Input() set margen(value: boolean) {
    if (value === true)
      this.classMargen = "jumbotron";
    else 
      this.classMargen = "jumbotron jumbotron-sinmargen";
    this._margen=value;
  };

  constructor(
    public databaseService: DatabaseService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    console.log('modo'+this.modoVisualizacion);
    this.databaseService.getContinents().get()
    .then(data => {
      this.continentes = [];
      data.forEach(d => {
        this.continentes.push(d.data());
      });
      console.log(this.continentes);
  });
}

  getPaises(event){
    console.log(event);
    //Guardo en una variable el continente seleccionado (lo da el comp.hijo)
    //Si hay una nueva seleccion de continente diferente al valor que tenia
    if(this.selectedContinent!=event){ 
      //Vuelvo a guardar ese nuevo value de continente
      this.selectedContinent=event; 
      //Vacío el value de country y city
      this.selectedCountry = this.selectedCity = ''; 
      //Y que no muestre las ciudades porque aun no he seleccionado pais
      this.ciudades = []; 
    }
    //Consigo de la BBDD los paises de ese continente
    this.databaseService.getCountries(event).get()
    .then(data => {
      this.paises = [];
      data.forEach(d => {
        this.paises.push(d.data());
      });
  });
  }

  getCiudades(event){
    console.log(event);
    //Si hay una nueva seleccion de pais diferente al valor que tenia
    if(this.selectedCountry!=event){ 
      //Vuelvo a guardar ese nuevo value de pais
      this.selectedCountry=event; 
      //Vacio el value de city
      this.selectedCity = ''; 
    }
    this.databaseService.getCities(event).get()
    .then(data => {
      this.ciudades = [];
      data.forEach(d => {
        this.ciudades.push(d.data());
      });
  });
  }

  getImage(event){
      var file = event.target.files[0];
      this.imageFile = file;
      this.imageFileName = Date.now() + file.name;
      this.imageUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(file));
    }
  
  

}
